// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// Initial State
import tableState from './initialState'
import datatable from './datatable'

// Assets Operator
import {
  initialState as operatorState,
  reducers as operatorReducers,
} from 'hfty-operator-asset'

// check and see if this should be added in this manner
import {
  initialState as fieldBorderOperatorState,
  reducers as fieldBorderOperatorReducers,
} from 'fc-operator-fieldborder'

// Exports
export default createReducer({
  ...tableState,
  ...operatorState,
  ...fieldBorderOperatorState,
}, {
  ...datatable.reducers,
  ...operatorReducers,
  ...fieldBorderOperatorReducers,
})
